import { Feld, grundGroesse, type FeldEigenschaften, type FeldGroesseGrund } from "./feld";

/**
 * Dateifeld (M-002, Preline `file-input-basic-usage-example`): natives Dateifeld mit Preline-Oberfläche.
 * Der Baustein prüft weder Typ noch Größe; `accept` und `hilfe` („PDF, höchstens 10 MB“) sagen es dem Nutzer, die
 * verbindliche Prüfung (Größe, Typ, Inhalt, Rechte) liegt in der Action des Aufrufers (SG-1, SG-6).
 */
type DateiRest = Omit<React.InputHTMLAttributes<HTMLInputElement>, "id" | "className" | "style" | "type" | "size" | "children" | "value" | "defaultValue">;

const KLASSEN: Record<FeldGroesseGrund, { normal: string; fehler: string }> = {
  standard: {
    normal:
      "block w-full bg-layer border border-layer-line rounded-lg text-sm text-foreground placeholder:text-muted-foreground-1 focus:z-10 focus:outline-hidden focus:border-primary-focus focus:ring-1 focus:ring-primary-focus disabled:opacity-50 disabled:pointer-events-none file:bg-surface file:border-0 file:me-4 file:py-3 file:px-4",
    fehler:
      "block w-full bg-layer border border-red-500 rounded-lg text-sm text-foreground placeholder:text-muted-foreground-1 focus:z-10 focus:outline-hidden focus:border-red-500 focus:ring-1 focus:ring-red-500 disabled:opacity-50 disabled:pointer-events-none file:bg-surface file:border-0 file:me-4 file:py-3 file:px-4",
  },
  kompakt: {
    normal:
      "block w-full bg-layer border border-layer-line rounded-lg text-sm text-foreground placeholder:text-muted-foreground-1 focus:z-10 focus:outline-hidden focus:border-primary-focus focus:ring-1 focus:ring-primary-focus disabled:opacity-50 disabled:pointer-events-none file:bg-surface file:border-0 file:me-3 file:py-2 file:px-3",
    fehler:
      "block w-full bg-layer border border-red-500 rounded-lg text-sm text-foreground placeholder:text-muted-foreground-1 focus:z-10 focus:outline-hidden focus:border-red-500 focus:ring-1 focus:ring-red-500 disabled:opacity-50 disabled:pointer-events-none file:bg-surface file:border-0 file:me-3 file:py-2 file:px-3",
  },
};

export function Dateifeld({
  id,
  label,
  labelVersteckt,
  optional,
  hilfe,
  fehler,
  hinweissatz,
  feldhilfe,
  layout,
  groesse = "standard",
  ...rest
}: FeldEigenschaften & DateiRest) {
  return (
    <Feld id={id} label={label} labelVersteckt={labelVersteckt} optional={optional} hilfe={hilfe} fehler={fehler} hinweissatz={hinweissatz} feldhilfe={feldhilfe} layout={layout} groesse={groesse}>
      {(a) => (
        <>
          {/* Preline: component/file-input/file-input-basic-usage-example */}
          <input
            {...rest}
            id={a.id}
            type="file"
            className={a.fehlerhaft ? KLASSEN[grundGroesse(groesse)].fehler : KLASSEN[grundGroesse(groesse)].normal}
            aria-describedby={a["aria-describedby"]}
            aria-invalid={a["aria-invalid"]}
          />
        </>
      )}
    </Feld>
  );
}
